<ion-card class="add-call-list-members-from-companies-card">
    <ion-card-header>
        Selected Companies
    </ion-card-header>
    <ion-card-content>
        <ion-item>
            <div class="add-call-list-members-from-companies-card--media-object">
                <ion-icon material-icons
                        small
                        name="account_circle"></ion-icon>
                <div class="add-call-list-members-from-companies-card--count-wrapper">
                    <apto-paragraph>{{ companies.length }} Companies</apto-paragraph>
                    <apto-help-text>
                        All related contacts are included
                    </apto-help-text>
                </div>
            </div>
        </ion-item>
        <div *ngIf="limitError"
             class="add-call-list-members-card--call-list-limit-error">
            <p>
                We cannot add {{ limitError.amountOver }} contacts to the {{ limitError.callList.name }} Call List with {{ limitError.callList.members.length
                }} contacts.
            </p>
            <p>
                You will exceed the limit of {{ CallListModel.CALL_LIST_MEMBER_LIMIT | number: '1.0-0'}} contacts per call list.
            </p>
            <p>
                Feel free to create a new Call List or remove contacts to then add to this list.
            </p>
        </div>
    </ion-card-content>
    <ion-row class="card-footer-buttons">
        <ion-col>
            <button ion-button
                    clear
                    class="clear-all-button"
                    (click)="onClearAllClick();">
                CLEAR ALL
            </button>
        </ion-col>
        <ion-col text-right>
            <add-to-list-button [contacts]="contacts"
                                [callLists]="allCallLists"
                                [isInitializing]="isInitializingCallLists || extractingContacts"
            ></add-to-list-button>
        </ion-col>
    </ion-row>
</ion-card>